import React from 'react';
import {observer} from 'mobx-react';
import {MatchEventsModuleStageViewModel} from "../models/match-events-module.stage-view-model";
import {MatchEventsModuleStage} from "./stage/match-events-module.stage";

export const MatchEventsModuleStages = observer(({controller}) => {
  const {state} = controller;
  const {shouldRenderStagesEmptyState, noEventLabel, stages} = state;

  return (
    <div className={'match-event-module-stages-container'}>
      {
        shouldRenderStagesEmptyState ? <div className={'match-event-module-stage-empty-state'}>{noEventLabel}</div> : null
      }
      {
        stages.map((stage: MatchEventsModuleStageViewModel) => <MatchEventsModuleStage
            stage={stage}
            key={stage.id}
            controller={controller}
          />
        )
      }
    </div>
  )
});
